<template>
  <div id="banner">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>培训考试&nbsp;/&nbsp;banner管理</span>
      </div>
      <div style="display: flex; flex-wrap: wrap; align-items: center">
        <Provinces @gain="gainSS"></Provinces>
        <!-- <el-input class="elinputs" v-model="beginData.id" placeholder=" 搜索编号"></el-input> -->
        <el-select
          v-model="beginData.type"
          placeholder="类型选择"
          class="elinputs"
        >
          <el-option
            v-for="item in beginData.types"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="beginData.bisshow"
          placeholder="是否显示"
          class="elinputs"
        >
          <el-option
            v-for="item in beginData.bisshows"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query(1)"
          >查询</el-button
        >
        <el-button type="info" @click="resets">重置</el-button>
      </div>
      <div class="tit">
        <Reset @clkBtn="theBtn"></Reset>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        id="exportTab"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="80"
          :index="1"
        ></el-table-column>
        <!-- <el-table-column prop="id" label="编号" width="100"></el-table-column> -->
        <el-table-column
          prop="typeName"
          label="类型"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="link"
          label="跳转地址"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="areasName"
          label="所属地区"
          width="160"
        ></el-table-column>
        <el-table-column min-width="110" label="缩略图">
          <template slot-scope="scope">
            <viewer v-if="scope.row.type != 1">
              <img class="sfzimg" :src="imgUrl + scope.row.coverImage" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column min-width="110" label="bannner图片">
          <template slot-scope="scope">
            <viewer>
              <img class="sfzimg" :src="imgUrl + scope.row.bannerImage" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" min-width="110">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.bisshow == 0">是</p>
            <p
              class="boldfont"
              v-if="scope.row.bisshow == 1"
              style="color: #f56c6c"
            >
              否
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(2, scope.row, 'banner:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="stop(scope.row, 'banner:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span>
          共
          <i class="pagingNum">{{ total }}</i> 条
        </span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      title="添加/编辑"
      :visible.sync="dialogFormVisible"
      @close="dataClose"
      width="60%"
    >
      <el-form>
        <el-form-item label="* 类 型：">
          <el-radio v-model="details.type" label="1" @change="empty(1)"
            >自定义</el-radio
          >
          <el-radio v-model="details.type" label="2" @change="empty(2)"
            >指定文章</el-radio
          >
          <el-radio v-model="details.type" label="3" @change="empty(3)"
            >指定视频</el-radio
          >
        </el-form-item>
        <el-form-item label="* 所属地区：">
          <el-select v-model="sheng" placeholder="省份" @change="cksheng">
            <el-option
              v-for="item in shenglist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="shi"
            placeholder="城市"
            @change="ckshi"
            class="cty16"
          >
            <el-option
              v-for="item in shilist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="details.type == 1">
          <el-form-item label="* 跳转地址：">
            <el-input
              placeholder="请输入跳转地址链接"
              v-model="details.link"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="details.type == 2">
          <el-form-item label="* 选择文章：">
            <el-input
              placeholder="请点击选择文章"
              v-model="details.previewName"
              auto-complete="off"
              :disabled="true"
            ></el-input
            ><el-button style="margin-left: 2%" type="primary" @click="ceshi(2)"
              >选择文章</el-button
            >
          </el-form-item>
          <el-form-item label="* 文章缩略图：">
            <viewer>
              <img
                :src="details.preview"
                style="width: 80px; margin-top: 18px"
              />
            </viewer>
          </el-form-item>
        </div>
        <div v-if="details.type == 3">
          <el-form-item label="* 选择视频：">
            <el-input
              placeholder="请点击选择视频"
              v-model="details.previewName"
              auto-complete="off"
              :disabled="true"
            ></el-input
            ><el-button style="margin-left: 2%" type="primary" @click="ceshi(3)"
              >选择视频</el-button
            >
          </el-form-item>
          <el-form-item label="* 视频缩略图：">
            <viewer>
              <img
                :src="details.preview"
                style="width: 80px; margin-top: 18px"
              />
            </viewer>
          </el-form-item>
        </div>
        <el-form-item label="* banner图片：" style="margin-bottom: 10px">
          <el-upload
            class="upload-demo"
            :action="URL"
            :limit="1"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :data="newobj"
            ref="upload"
            :file-list="details.cover"
            name="multipartFile"
            :headers="newhead"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              选择banner图片，推荐尺寸800*600px，大小100k以内
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="* 是否显示：">
          <el-radio v-model="details.bisshow" label="0">是</el-radio>
          <el-radio v-model="details.bisshow" label="1">否</el-radio>
        </el-form-item>
      </el-form>
      <el-dialog
        title="文章/视频选择"
        :visible.sync="innerVisible"
        append-to-body
        id="datatext"
        width="60%"
      >
        <el-form>
          <el-input
            class="elinputs"
            style="margin-bottom: 26px"
            v-model="beginData.id"
            placeholder=" 搜索编号"
          ></el-input>
          <el-button style="margin-right: 16px" type="primary" @click="query(2)"
            >查询</el-button
          >
          <el-table
            :data="tableData2"
            v-if="details.type == 2"
            id="exportTab"
            border
            stripe
            style="width: 100%"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              :index="1"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              width="160"
            ></el-table-column>
            <el-table-column min-width="110" label="缩略图">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl + scope.row.coverImage" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column
              prop="label"
              label="标签"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="cname"
              label="所属分类"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="readFalse"
              label="浏览次数（假）"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="readTrue"
              label="浏览次数（真）"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="添加时间"
              width="110"
            ></el-table-column>
            <el-table-column
              prop="modifyTime"
              label="修改时间"
              width="110"
            ></el-table-column>
            <el-table-column label="是否显示" sortable width="110">
              <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.isshow == 0">是</p>
                <p
                  class="boldfont"
                  v-if="scope.row.isshow == 1"
                  style="color: #f56c6c"
                >
                  否
                </p>
              </template>
            </el-table-column>
            <el-table-column label="是否置顶" sortable width="110">
              <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.istop == 0">是</p>
                <p
                  class="boldfont"
                  v-if="scope.row.istop == 1"
                  style="color: #f56c6c"
                >
                  否
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="110">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="choice(2, scope.row)"
                >
                  <i class="el-icon-edit"></i>选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            :data="tableData3"
            v-if="details.type == 3"
            id="exportTab"
            border
            stripe
            style="width: 100%"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              :index="1"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              width="160"
            ></el-table-column>
            <el-table-column min-width="110" label="封面图">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl + scope.row.coverImage" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column
              prop="label"
              label="标签"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="cname"
              label="所属分类"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="readFalse"
              label="浏览次数（假）"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="readTrue"
              label="浏览次数（真）"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="createtime"
              label="添加时间"
              width="110"
            ></el-table-column>
            <el-table-column
              prop="modifytime"
              label="修改时间"
              width="110"
            ></el-table-column>
            <el-table-column label="是否显示" sortable width="110">
              <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.isshow == 0">是</p>
                <p
                  class="boldfont"
                  v-if="scope.row.isshow == 1"
                  style="color: #f56c6c"
                >
                  否
                </p>
              </template>
            </el-table-column>
            <el-table-column label="是否置顶" sortable width="110">
              <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.istop == 0">是</p>
                <p
                  class="boldfont"
                  v-if="scope.row.istop == 1"
                  style="color: #f56c6c"
                >
                  否
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="choice(3, scope.row)"
                >
                  <i class="el-icon-edit"></i>选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <span
              >共<i class="pagingNum">{{ textdata.total }}</i> 条</span
            >
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="textdata.pageNum"
              :page-sizes="[10, 30, 50, 100, 200]"
              :page-size="textdata.pageSize"
              layout="sizes, prev, pager, next"
              :total="textdata.total"
            ></el-pagination>
          </div>
        </el-form>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="puton">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Xlsx from "@/components/Xlsx";
import EditorBar from "@/components/Richtext";
import Reset from "@/components/Reset";
import Paging from "@/components/Paging";
export default {
  name: "banner",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces,
  },
  data() {
    return {
      beginData: {
        bisshows: [
          { id: 0, name: "是" },
          { id: 1, name: "否" },
        ],
        types: [
          { id: 1, name: "自定义" },
          { id: 2, name: "指定文章" },
          { id: 3, name: "指定视频" },
        ],
      },
      textdata: { pageNum: 1, pageSize: 10, total: 0 },
      tableData: [],
      tableData2: [],
      tableData3: [],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      innerVisible: false,
      details: { bisshow: "0", type: "1" },
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      imgurl: "",
      imgUrl: this.$Public.imgUrl,
      formname: JSON.stringify({ name: "banner管理", hint: "banner:export" }),
      URL: `${this.$Public.URL}/api-r/upload/uploadImg`,
      videoURL: `${this.$Public.URL}/api-e/upload/uploadVideo`,
      newobj: { type: 2 },
      newhead: {
        accessToken: JSON.parse(sessionStorage.getItem("userdata")).token,
      },

      sheng: "",
      shengName: '',
      shi: "",
      shenglist: [],
      shilist: [],
      status: "",
      bannerImage: "",
      multipleSelection: [],
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  watch: {
    // 'details.type':{
    //   handler: function() {
    //     this.details = {type:`${this.details.type}`}
    //   },
    // }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem("region"));
    region.forEach((x) => {
      if (x.level == 0) {
        this.shenglist.push(x);
        this.sheng = x.id;
        this.shengName = x.name;
      }
    });
    if (this.userdata.level == 0) {
      this.$axios
        .post(
          `/api-r/area/getSubordinateAreaList`,
          this.$qs.stringify({ areasId: region[0].id }),
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          if (res.data.success) {
            this.$set(this, "shilist", res.data.areaListInfoList);
          }
        });
    } else {
      region.forEach((x) => {
        if (x.level == 1) {
          this.shilist.push(x);
        }
      });
      if (this.shilist.length == 1) {
        this.shi = this.shilist[0].id;
        this.details.areasid = this.sheng + "," + this.shilist[0].id;
        this.details.areasName = this.shengName + "," + this.shilist[0].name;
      }
    }
  },
  methods: {
    //   判断当前点击的按钮
    theBtn(i) {
      if (i == 1) {
        if (this.btn.indexOf("banner:add") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        this.handleEdit(1);
      } else if (i == 2) {
        if (this.btn.indexOf("banner:update") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        if (this.multipleSelection.length != 1) {
          return this.$message("请勾选一项内容编辑");
        }
        this.handleEdit(2, this.multipleSelection[0]);
      } else if (i == 3) {
        if (this.btn.indexOf("banner:delete") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        this.choices();
      } else if (i == 4) {
        this.query();
      }
    },
    //   多选编辑
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //   多选删除
    choices() {
      if (this.multipleSelection.length == 0) {
        return this.$message("请至少选择一项删除");
      }
      let arr = [];
      this.multipleSelection.forEach((x) => {
        arr.push(x.id);
      });
      this.$confirm("此操作将删除选中内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          if (this.activeName == "first") {
            url = `/api-e/video/deleteVideo/${arr.join(",")}`;
          } else {
            url = `/api-e/category/deleteCategory/${arr.join(",")}`;
          }
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.begin();
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    empty(x) {
      this.details = { areasid: this.details.areasid , areasName: this.details.areasName , bisshow: "0", type: `${x}` };
    },
    ceshi(x) {
      if (x == 2) {
        this.gettext();
      } else {
        this.getvideo();
      }
    },
    // 点击选择获取内容
    choice(x, row) {
      this.details.preview = this.imgUrl + row.coverImage;
      this.details.oid = row.id;
      this.details.coverImage = row.coverImage;
      this.details.previewName = row.title;
      this.details.link = row.title;
      this.innerVisible = false;
    },
    handlePreview(file) {
      window.open(file.vidUrl, "_blank");
    },
    // 获取视频列表
    getvideo() {
      let vidtext = this.$qs.stringify({
        pageNum: this.textdata.pageNum,
        pageSize: this.textdata.pageSize,
        id: this.beginData.id,
        type: this.beginData.type,
        areasid: this.userdata.areasId,
      });
      this.$axios
        .post(`/api-e/video/videoLists`, vidtext, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.innerVisible = true;
          if (res.data.success) {
            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData3", res.data.pageInfo.list);
              this.textdata.total = res.data.pageInfo.total;
            });
          }
        });
    },
    // 获取文章列表
    gettext() {
      // 获取视频列表和文章列表
      let vidtext = this.$qs.stringify({
        pageNum: this.textdata.pageNum,
        pageSize: this.textdata.pageSize,
        id: this.beginData.id,
        type: this.beginData.type,
        areasid: this.userdata.areasId,
      });
      this.$axios
        .post(`/api-e/article/articleLists`, vidtext, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.innerVisible = true;
          if (res.data.success) {
            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData2", res.data.pageInfo.list);
              this.textdata.total = res.data.pageInfo.total;
            });
            // this.$set(this, "total", res.data.pageInfo.total);
          }
        });
    },
    handleClick(tab, event) {
      this.begin();
    },
    // 关闭清空内容
    dataClose() {
      if (this.shilist.length == 1) {
        this.details = {
          bisshow: "0",
          type: "1",
          areasid: this.sheng + "," + this.shilist[0].id,
        };
      } else {
        this.shi = "";
        this.details = { bisshow: "0", type: "1" };
      }
    },
    change(val) {
      console.log(val);
    },
    // 提交
    puton() {
      this.details.bannerImage = this.bannerImage;
      if (this.details.areasid == undefined || this.details.areasid == "") {
        return this.$message("请选择所属地区");
      }
      if (this.details.type == 1) {
        if (
          !this.details.link ||
          this.details.link == "" ||
          this.details.bannerImage == "" ||
          !this.details.bannerImage
        ) {
          return this.$message("请完善内容填写");
        }
      } else if (this.details.type == 2) {
        if (
          !this.details.preview ||
          this.details.preview == "" ||
          this.details.bannerImage == "" ||
          !this.details.bannerImage
        ) {
          return this.$message("请完善内容填写");
        }
      } else if (this.details.type == 3) {
        if (
          !this.details.preview ||
          this.details.preview == "" ||
          this.details.bannerImage == "" ||
          !this.details.bannerImage
        ) {
          return this.$message("请完善内容填写");
        }
      }

      let url = "";
      if (this.status == 1) {
        url = `/api-e/banner/addBanner`;
      } else if (this.status == 2) {
        url = `/api-e/banner/updateBanner`;
      }
      this.fullscreenLoading = true;
      this.$axios
        .post(url, this.$qs.stringify(this.details), {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.dialogFormVisible = false;
          this.begin();
          this.$refs.upload.clearFiles();
        });
    },
    // 地区id
    cksheng(val) {
      this.$set(this, "shi", "");
    },
    ckshi(val) {
      this.details.areasid = this.sheng + "," + val;
      let addName = "";
      this.shilist.forEach((x) => {
        if (val == x.id) {
          addName = x.name;
        }
      });
      this.details.areasName = this.shenglist[0].name + "," + addName;
    },
    // banner图处理
    handleRemove(file, fileList) {
      this.bannerImage = "";
    },
    handleAvatarSuccess(res, file) {
      this.bannerImage = res.url;
    },
    resets() {
      this.$router.push("/refresh");
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.begin();
    },
    handleSizeChange(x, val) {
      this.pageSize = val;
      this.fullscreenLoading = true;
      if (this.details.type == 1) {
        this.begin();
      } else if (this.details.type == 2) {
        this.gettext();
      } else if (this.details.type == 3) {
        this.getvideo();
      }
    },
    handleCurrentChange(x, val) {
      this.pageNum = val;
      this.fullscreenLoading = true;
      if (this.details.type == 1) {
        this.begin();
      } else if (this.details.type == 2) {
        this.gettext();
      } else if (this.details.type == 3) {
        this.getvideo();
      }
    },
    // 获取省市传入的id
    gainSS(i) {
      this.beginData.areasId = i.id;
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        // helperName: this.poper,
        // helperPhone: this.helperPhone,
        // adminAreasId: userdata.areasId,
        id: this.beginData.id,
        bisshow: this.beginData.bisshow,
        type: this.beginData.type,
        areasid: userdata.areasId,
        areaId: this.beginData.areasId,
      });
      this.$axios
        .post(`/api-e/banner/bannerList`, data, {
          headers: { accessToken: userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            // this.$set(this, "tableData", res.data.pageInfo.list);

            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    handleEdit(i, row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.status = i;
      if (i == 2) {
        this.details.type = Number();
        let str = row.bisshow + "";
        this.details.bisshow = str;
        let strtype = row.type + "";
        this.details.type = strtype;
        this.details.id = row.id;
        this.details.oid = row.oid;
        this.details.areasid = row.areasid;
        this.details.preview = this.imgUrl + row.coverImage;
        this.details.cover = [
          { name: "banner图片", url: `${this.imgUrl + row.bannerImage}` },
        ];
        this.bannerImage = row.bannerImage;
        this.sheng = Number(row.areasid.split(",")[0]);
        this.shi = Number(row.areasid.split(",")[1]);
        this.details.link = row.link;
        if (row.type == "2") {
          this.details.previewName = "文章（1）";
        } else if (row.type == "3") {
          this.details.previewName = "视频（1）";
        }
      }
      this.dialogFormVisible = true;
    },
    stop(row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将删除该条内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          url = `/api-e/banner/deleteBanner/${row.id}`;
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.begin();
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    query(x) {
      this.fullscreenLoading = true;
      if (this.details.type == 1) {
        this.begin();
      } else if (this.details.type == 2) {
        this.gettext();
      } else if (this.details.type == 3) {
        this.getvideo();
      }
    },
  },
};
</script>
<style>
.w-e-toolbar {
  flex-wrap: wrap;
}
#banner .el-input__inner {
  margin: 10px 0;
}
#banner .el-menu.el-menu--horizontal {
  margin-bottom: 14px;
}
#banner .el-menu-item.is-active {
  background: none;
}
#banner .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#banner .el-tag {
  margin-right: 12px;
}
#banner .el-select {
  /* margin: 0 8px; */
  width: 100%;
}
#banner .el-upload__tip {
  display: inline-block;
  margin-left: 14px;
}
#banner .el-table th,
.el-table td {
  text-align: center;
}
.input-new-tag {
  width: 20%;
}
#banner .el-upload-list--picture .el-upload-list__item {
  /* width: 44%; */
  float: left;
  margin-right: 2%;
}
#banner .el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
}
#banner .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#banner .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#banner .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#banner .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#banner .el-dialog__body {
  height: 100%;
}
#datatext .el-dialog__body {
  min-height: 150px !important;
}
#banner .el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
#banner .el-form-item__label {
  width: 160px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx {
  color: red;
  margin-left: 8px;
}
</style>
